export default __webpack_public_path__ + "static/oeko-459a638296b3b747fe47db9c17daf691.svg";